import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import styles from './ReferralLanding.module.scss';
import {Button, Dimmer, Image, Input, Loader} from 'semantic-ui-react';
import axios from 'axios';
import {useParams} from "react-router-dom";
import {empty} from "../helpers/general";
import {message} from "antd";
import {handleGeneralError} from "../classes/ErrorHandler";
import logoAppstore from "../assets/images/logo-appstore@2x.png";
import logoPlaystore from "../assets/images/logo-googleplay@2x.png";
import { API_BASE_URL } from "../utils/constants";
import {EP_REFERRAL} from "../utils/endpoints";

const ReferralLanding = () => {
    let {referralCode} = useParams();
    const [pageLoading, setPageLoading] = useState(false);
    const [page, setPage] = useState('home');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [referralErrorMessage, setReferralErrorMessage] = useState('');

    interface BusinessData {
        brand_name: string;
        brand_logo: string;
        potential_reward_message: string;
    }

    const [businessData, setBusinessData] = useState<BusinessData | null>(null);
    useEffect(() => {
        setPageLoading(true);
        axios
            .get(API_BASE_URL + EP_REFERRAL + `?mref=${referralCode}`)
            .then(res => {
                setBusinessData(res.data);
            })
            .catch(err => {
                setPage('error');
                handleGeneralError(err, (msg: string) => {
                    message.error(msg);
                    setReferralErrorMessage(msg)
                });
            })
            .finally(() => {
                setPageLoading(false);
            });
    }, [referralCode]);

    const checkPhoneNumber = (e?: React.FormEvent<HTMLFormElement>) => {
        if (!empty(e)) {
            e?.stopPropagation();
            e?.preventDefault();
        }

        if (empty(phoneNumber)) {
            message.error('Please input your phone number.');
        } else {
            setPageLoading(true);
            axios
                .post(
                    API_BASE_URL + EP_REFERRAL,
                    {
                        country_code: '+62',
                        phone: phoneNumber,
                        mref: referralCode
                    }
                )
                .then(res => {
                    setPage('success');
                })
                .catch(err => {
                    handleGeneralError(err, (msg: string) => {
                        message.error(msg);
                    });
                })
                .finally(() => {
                    setPageLoading(false);
                });
        }
    };

    return (
        <div className={styles.baseWrapper}>
            <Helmet>
                <title>Referral | Get Diskon</title>
            </Helmet>

            {pageLoading && (
                <Dimmer active inverted>
                    <Loader inverted content='Loading'/>
                </Dimmer>
            )}

            {page === 'home' && (
                <div className={styles.sectionWrapper}>
                    <div style={{textAlign: 'center'}}>
                        <Image src={businessData?.brand_logo}
                               alt={businessData?.brand_name}
                               size={`small`}
                               style={{margin: 'auto'}}
                               circular/>
                        <h1>{businessData?.brand_name}</h1>

                        {!empty(businessData?.potential_reward_message) && (
                            <p>{businessData?.potential_reward_message}</p>
                        )}
                    </div>

                    <form onSubmit={checkPhoneNumber}>
                        <div style={{margin: '20px 0'}}>
                            <Input label={`+62`}
                                   placeholder="Phone Number"
                                   style={{width: '100%'}}
                                   value={phoneNumber}
                                   onChange={e => {
                                       setPhoneNumber(e.target.value)
                                   }}
                            />
                        </div>

                        <Button fluid color="green">Join</Button>
                    </form>
                </div>
            )}

            {page === 'success' && (
                <div className={styles.sectionWrapper}>
                    <div style={{textAlign: 'center'}}>
                        <Image src={businessData?.brand_logo}
                               alt={businessData?.brand_name}
                               size={`small`}
                               style={{margin: 'auto'}}
                               circular/>
                        <h1>{businessData?.brand_name}</h1>
                    </div>

                    <p className={styles.successText}>Kamu telah berhasil menjadi member {businessData?.brand_name}! Tinggal satu langkah lagi, download dan sign-up di aplikasi Get Diskon untuk melihat bonus poinmu!</p>

                    <div className={styles.storeLogos}>
                        <a href="https://play.google.com/store/apps/details?id=com.itk.getdiskon" target="_blank" rel="noreferrer noopener">
                            <img src={logoPlaystore} alt="Get Diskon Android App" />
                        </a>
                        <a href="https://itunes.apple.com/in/app/get-diskon/id1247078124" target="_blank" rel="noreferrer noopener">
                            <img src={logoAppstore} alt="Get Diskon iOS App" />
                        </a>
                    </div>
                </div>
            )}

            {page === 'error' && (
                <div className={styles.sectionWrapper}>
                    <div style={{textAlign: 'center', margin: '30px 0'}}>
                        <h1>{referralErrorMessage}</h1>
                    </div>

                    <div className={styles.storeLogos}>
                        <a href="https://play.google.com/store/apps/details?id=com.itk.getdiskon" target="_blank" rel="noreferrer noopener">
                            <img src={logoPlaystore} alt="Get Diskon Android App" />
                        </a>
                        <a href="https://itunes.apple.com/in/app/get-diskon/id1247078124" target="_blank" rel="noreferrer noopener">
                            <img src={logoAppstore} alt="Get Diskon iOS App" />
                        </a>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ReferralLanding;